import React from 'react';
import ReactPaginate from 'react-paginate';
import './pagination.css'; // Add custom styles for pagination

const Pagination = ({ pageCount, currentPage, onPageChange }) => {
    return (
        <ReactPaginate
            breakLabel="..."
            nextLabel="Siguiente >"
            previousLabel="< Anterior"
            onPageChange={(event) => onPageChange(event.selected + 1)}
            pageRangeDisplayed={3} // Show one page before and after the selected page
            marginPagesDisplayed={2} // Show the first two and last two pages
            pageCount={pageCount}
            forcePage={currentPage - 1} // ReactPaginate uses zero-based indexing
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
            disabledClassName="disabled"
        />
    );
};

export default Pagination;